import {NotificationMessage} from "./NotificationMessage";
import React from "react";
import {Link} from "react-router-dom";

export const NewMasterclassCommentNotification = ({ notification }) => {
    const masterclass = notification.entities.find((dataEntity) => dataEntity.type === 'masterclass').data;
    const comment = notification.entities.find((dataEntity) => dataEntity.type === 'comment').data;
    const masterclassId = masterclass.id;
    const message = notification.message;
    const linkTo = '/master-classes/' + masterclassId;

    return (
        <div style={{display: "flex", flexDirection: "column"}}>
            <NotificationMessage
                message={message}
                linkTo={linkTo}
            />
            <Link to={'/comments/' + comment.id} className="notification__masterclass-comment__comment-text">
                {comment?.body}
            </Link>
        </div>
    );
};